/* Film in der Join-Section: laeuft stumm in Schleife, Antippen pausiert.
   Bewusst ohne native Controls, sonst kommt die Vollbild-Taste mit. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.smeluJoinInit === '1') return;
    root.dataset.smeluJoinInit = '1';

    var media = root.querySelector('.smelu-join__media');
    var video = root.querySelector('[data-smelu-join-video]');
    var tap = root.querySelector('[data-smelu-join-tap]');
    if (!media || !video || !tap) return;

    function sync() {
      media.classList.toggle('is-paused', video.paused);
      tap.setAttribute('aria-label', video.paused ? 'Video abspielen' : 'Video pausieren');
    }

    tap.addEventListener('click', function () {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else { video.pause(); }
      sync();
    });

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    // Ausserhalb des Bildes nicht weiterlaufen lassen: spart Akku und Daten.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else if (!video.paused) { video.pause(); media.classList.remove('is-paused'); }
        });
      }, { threshold: 0.25 });
      io.observe(media);
    }

    sync();
  }

  function boot() { document.querySelectorAll('[data-smelu-join]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Aufklappbare Punkte (26.08.2026, nur wenn points_interactive gesetzt).
   Akkordeon wie in der Konstruktionsfehler-Section: einer offen, Rest zu.
   Ohne JS bleibt alles offen und lesbar. */
(function () {
  'use strict';
  function init(list) {
    var items = [].slice.call(list.querySelectorAll('.smelu-join__point--tap'));
    if (!items.length) return;
    list.classList.add('is-ready');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-join-point]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (o) {
          o.classList.remove('is-open');
          var b = o.querySelector('[data-join-point]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  function boot() {
    [].slice.call(document.querySelectorAll('[data-join-points]')).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
